import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IShoppingCart, IPaymentLine } from "./shoppingCart.interfaces";
import { IPaymentMethod } from "@thekilroygroup/shared-ui";

const initialState: IShoppingCart = {
  selectedPaymentMethod: null,
  acceptedTermsAndConditions: false,
  paymentLines: [],
};

export const shoppingCartSlice = createSlice({
  name: "shoppingCart",
  initialState,
  reducers: {
    setPaymentMethod: (state, action: PayloadAction<IPaymentMethod>) => {
      state.selectedPaymentMethod = action.payload;
    },
    setTermsAndConditions: (state, action: PayloadAction<boolean>) => {
      state.acceptedTermsAndConditions = action.payload;
    },
    addPaymentLine: (state, action: PayloadAction<IPaymentLine>) => {
      state.paymentLines = [
        ...state.paymentLines.filter((item) => item.key !== action.payload.key),
        action.payload,
      ];
    },
    removePaymentLine: (state, action: PayloadAction<{ key: string }>) => {
      state.paymentLines = state.paymentLines.filter(
        (line) => line.key !== action.payload.key,
      );
    },
    resetShoppingCart: (state) => {
      state.selectedPaymentMethod = null;
      state.acceptedTermsAndConditions = false;
      state.paymentLines = [];
    },
  },
});

export const {
  setPaymentMethod,
  setTermsAndConditions,
  removePaymentLine,
  addPaymentLine,
  resetShoppingCart,
} = shoppingCartSlice.actions;
